// extracted by mini-css-extract-plugin
export var currencyInput = "_ko-1";
export var currencySymbol = "_ko-0";